// GENERATED FILE - DO NOT MODIFY

export enum GetAmenityCategoriesSortColumnDto {
    Order = "Order",
    LastUsed = "LastUsed",
    Name = "Name",
}